import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ArrowLeft } from 'lucide-react';
import { classroomAPI } from '../utils/api';
import { toast } from 'sonner';

const JoinClassroom = () => {
  const navigate = useNavigate();
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleJoin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await classroomAPI.join(accessCode);
      toast.success('Você entrou na sala de aula!');
      navigate('/student/egg');
    } catch (error) {
      console.error('Failed to join classroom:', error);
      if (error.response?.status === 404) {
        toast.error('Código inválido. Verifique e tente novamente.');
      } else {
        toast.error('Erro ao entrar na sala. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Button
          data-testid="back-btn"
          onClick={() => navigate('/student/dashboard')}
          variant="ghost"
          className="mb-4 flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </Button>

        <div className="bg-white rounded-2xl border-2 border-slate-100 shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🚪</div>
            <h1 className="text-3xl font-outfit font-black text-slate-900 mb-2" data-testid="join-title">Entrar em uma Sala</h1>
            <p className="text-slate-600 font-nunito">Digite o código fornecido pelo professor</p>
          </div>

          <form onSubmit={handleJoin} className="space-y-6">
            <div>
              <Label htmlFor="access-code" className="font-nunito text-base">Código de Acesso</Label>
              <Input
                id="access-code"
                data-testid="access-code-input"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
                placeholder="Ex: ABC123"
                required
                maxLength={6}
                className="mt-2 h-14 text-center text-2xl font-mono font-bold tracking-wider uppercase"
              />
            </div>

            <Button
              data-testid="submit-join-btn"
              type="submit"
              disabled={loading || accessCode.length < 6}
              className="w-full bg-primary hover:bg-primary/90 text-white h-12 rounded-xl font-bold shadow-lg transition-all"
            >
              {loading ? 'Entrando...' : 'Entrar na Sala'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JoinClassroom;
